export const cardPanelItems: Array<{ text: string , total: number, link: string }> = [
    {
      text: `Stock`,
      total: 8,
      link: "./stock"
    },
    {
      text: 'Merchant Orders',
      total: 8,
      link: "./orders"
    },
    {
      text: 'Active',
      total: 8,
      link: "./active"
    },
    {
        text: 'Deactivated',
        total: 8,
        link: "./deactivated"
      }
  ];